/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {Material} from '../models/material';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';

export class MaterialStore extends EntityStore {
  materials = [];

  constructor(rootStore) {
    super(rootStore, 'materials', Api.materials, Material, true);
  }

  async searchByNoAndName({params}) {
    return this.api.search(params).then((response) => response.data);
  }
}

decorate(MaterialStore, {
  materials: observable,
});
